import React from 'react';
import useSWR from 'swr';
import _ from 'lodash';
import { swrFetcher } from 'utils/api';
import { useUserAuth } from 'contexts/UserAuth';

const { createContext, useContext } = React;
export const UserDataContext = createContext({});
UserDataContext.displayName = 'UserData';

export const UserDataProvider = (props) => {
  const { user: sorraUser, getAuthorizationHeader } = useUserAuth();
  const { children } = props;
  const {
    data: vouchers,
    isLoading: isVouchersLoading,
    mutate: mutateVouchers,
  } = useSWR(
    sorraUser ? '/api/v3/me/scoreVouchers' : null,
    (url) => swrFetcher(url, getAuthorizationHeader),
    { fallbackData: [] }
  );

  const voucherQuantity = _.reduce(
    vouchers,
    (acc, c) => {
      return acc + (c.count || 0);
    },
    0
  );

  const contextValue = {
    // Original User Data
    vouchers: vouchers || [],
    isVouchersLoading,
    mutateVouchers,

    // Derived Data
    voucherQuantity,

    // Functions
  };

  return (
    <UserDataContext.Provider value={contextValue}>
      {children}
    </UserDataContext.Provider>
  );
};

export const useUserData = () => {
  const context = useContext(UserDataContext);

  if (!context) {
    throw new Error('useUserData must be used within a UserDataProvider');
  }
  return context;
};
